import React from "react";
import { Routes, Route } from "react-router-dom";
import { LandingPage, VideoPage } from "./components";

export const config = {
  // endpoint: "https://5e84170a-136b-4b77-b450-f82354114caf.mock.pstmn.io/v1"
  endpoint: "https://31de3a79-7c56-41d7-9d26-f867a2a464a1.mock.pstmn.io/v1",
};

const App = () => {
  return (
    <React.StrictMode>
      <Routes>
        <Route path="/" exact element={<LandingPage />} />
        <Route path="/video/:id" element={<VideoPage />} />
      </Routes>
    </React.StrictMode>
  );
};

export default App;
